import { PromoPercentagesSchema, usePromotion } from '@mc/promo-utils'

export const useDiscountPercent = (): number | undefined => {
  const { variables } = usePromotion()
  const parsed = PromoPercentagesSchema.safeParse(variables.percentages)

  return parsed.success ? Math.max(...Object.values(parsed.data)) : undefined
}
